import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { useDeliveryService } from "../../../services/deliveryService"

export const useActions = () => {
    const { annulDelivery } = useDeliveryService()

    const { closeModal } = useUIActions()

    const submitAnnulDelivery = async (deliveryId: string) => {
        Emitter.emit(Event.DB_SUBMIT)

        try {
            await annulDelivery(deliveryId)

            Emitter.emit(Event.DB_SUBMIT_DONE, false, false)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo anular la entrega.')
        }
    }

    return {
        submitAnnulDelivery
    }
}
